import React, { useEffect, useState } from "react";
import BarTitle from "../../components/BarTitle";
import Painel from "../../components/Painel";
import "bootstrap-daterangepicker/daterangepicker.css";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import Axios from "axios";
import constants from "../../constants";
import InputMask from "react-input-mask";
import swal from "sweetalert";
import * as XLSX from "xlsx";

let initialSettingsDatePicker = {
  minDate: "01/01/2015",
  maxDate: moment(new Date()),
  opens: "left",
  locale: {
    applyLabel: "Aplicar",
    fromLabel: "De",
    format: "DD/MM/YYYY",
    toLabel: "à",
    separator: " à ",
    cancelLabel: "Cancelar",
    customRangeLabel: "Data Customizada",
    daysOfWeek: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
    monthNames: [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ],
  },
  ranges: {
    Hoje: [moment(new Date())],
    Ontem: [moment().subtract(1, "days"), moment().subtract(1, "days")],
    "Últimos 7 Dias": [moment().subtract(6, "days"), moment()],
    "Últimos 30 Dias": [moment().subtract(29, "days"), moment()],
    "Este Mês": [moment().startOf("month"), moment().endOf("month")],
    "Mês Passado": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  },
};

export default function DriverReport() {
  const [paymentSolicitation, setPaymentSolicitation] = useState([]);
  const [start_time, set_start_time] = useState(
    moment(new Date()).format("DD/MM/YYYY")
  );
  const [end_time, set_end_time] = useState(
    moment(new Date()).clone().add(1, "days").format("DD/MM/YYYY")
  );
  const [displayDate, setDisplayDate] = useState({});

  const [status, setStatus] = useState({
    aprovado: false,
    rejeitado: false,
    cancelado: false,
    pendente: false,
  });
  const [cpf, setCpf] = useState("");
  const [documentData, setDocumentData] = useState("");
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    // ACORDA HEROKU
    Axios.post("https://super-image-api.herokuapp.com/all-fast-report/").then(
      () => {}
    );
  }, []);

  function handleEvent(event, picker) {
    set_start_time(picker.startDate.format("DD/MM/YYYY"));
    set_end_time(picker.endDate.clone().add(1, "days").format("DD/MM/YYYY"));
    setDisplayDate({
      start_time: picker.startDate.format("DD/MM/YYYY"),
      end_time: picker.endDate.format("DD/MM/YYYY"),
    });
  }

  function handleGetDrivers(params) {
    let data = { start_time, end_time };
    const url =
      constants().URL_SERVICE +
      "establishment/establishment/get_report_driver/";

    setShowLoading(true);
    Axios.post(url, data, {
      headers: { Authorization: "Token " + localStorage.token },
    })
      .then((response) => {

        setShowLoading(false);
        setPaymentSolicitation(response.data.list);

        /* make the worksheet */
        const container = [];
        let pricePerDriver = 0;
        let allPrice = 0;
        function percentage(num, per) {
          return (num / 100) * per;
        }
        function invertedPercentage(num, per) {
          return num - ((num / 100) * per);
        }
        Object.keys(response.data.report).map((key) => {
          response.data.report[key].map((item) => {
            let data = {};
            data["Tipo"] = item.type;
            data["Data"] = item.date;
            data["Motorista"] = item.driver;
            data["Nome"] = item.username;
            data["Preço"] = item.price;
            allPrice = allPrice + item.price;
            container.push(data);
            pricePerDriver = pricePerDriver + item.price;
          });
          container.push("");
          container.push({ Tipo: "Total: R$" + pricePerDriver.toFixed(2) });
          container.push({ Tipo: "Taxa AllFast: R$" + percentage(pricePerDriver, 10).toFixed(2)});
          container.push({ Tipo: "Valor à pagar: R$" + invertedPercentage(pricePerDriver, 10).toFixed(2) });
          container.push("");
          pricePerDriver = 0;
        });
        container.push({ Tipo: "Total Geral: R$" + allPrice.toFixed(2) });
        container.push({ Tipo: "Taxa AllFast: R$" + percentage(allPrice, 10).toFixed(2)});
          container.push({ Tipo: "Valor à pagar: R$" + invertedPercentage(allPrice, 10).toFixed(2) });
        var headers = Object.keys(container[0]);
        var ws = XLSX.utils.json_to_sheet(container, {
          header: headers,
        });

        /* add to workbook */
        var wb = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(wb, ws, "Financial Report");

        /* generate an XLSX file */
        XLSX.writeFile(
          wb,
          "Relatório de motoristas  " +
            moment(new Date()).format("DD/MM/YYYY") +
            ".xlsx"
        );
      })
      .catch((error) => console.error(error));
  }

  function handleExportDocument() {}

  function exportReportPDF() {
    let data = {
      start_time,
      end_time,
      status,
      cpf,
      displayDate,
      date: moment().format("DD/MM/YYYY"),
      time: moment().format("LT"),
    };
    const url = "https://super-image-api.herokuapp.com/all-fast-report/";

    setShowLoading(true);

    Axios.post(url, data, {
      headers: { Authorization: "Token " + localStorage.token },
    })
      .then((response) => {
        // setShowLoading(false);
        // var win = window.open(response.data.path);
        // win.focus();
        setShowLoading(false);
        const el = document.createElement("div");
        el.innerHTML = `<a target="_blank" class="btn btn-primary" href='${response.data.path}'>Clique aqui para baixar o relatório em formato PDF.</a>`;

        swal({
          title: "Relatório de pagamento",
          content: el,
        });
      })
      .catch((error) => {
        setShowLoading(false);
        this.setState({ error: true });
      });
  }

  return (
    <div>
      <BarTitle name="Relatórios Motoristas" />
      <div className="padder padder-top-30 ">
        <Painel className="">
          <div class="reports-search-painel">
            <div>
              <span className="sub-title">Período</span>
              <DateRangePicker
                initialSettings={initialSettingsDatePicker}
                onEvent={handleEvent}
              >
                <input type="text" className="form-control col-1 data-input" />
              </DateRangePicker>
            </div>
            <div>
              <a
                onClick={handleGetDrivers}
                style={{ width: "300px" }}
                type="button"
                class="btn btn-info"
              >
                Gerar relatório
              </a>
            </div>
          </div>
        </Painel>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/views/DriverReports/index.js